// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Svg = require("./Svg.bs.js");
var React = require("react");

function Checkmark(Props) {
  return React.createElement(Svg.make, {
              children: null,
              title: "checkmark"
            }, React.createElement("circle", {
                  cx: "32",
                  cy: "32",
                  fill: "#4bd37b",
                  r: "30"
                }), React.createElement("path", {
                  d: "m46 14l-21 21.6-7-7.2-7 7.2 14 14.4 28-28.8z",
                  fill: "#fff"
                }));
}

var make = Checkmark;

exports.make = make;
/* Svg Not a pure module */
